import { render, staticRenderFns } from "./questionnaireEdit.vue?vue&type=template&id=b40f425a"
import script from "./questionnaireEdit.vue?vue&type=script&lang=js"
export * from "./questionnaireEdit.vue?vue&type=script&lang=js"
import style0 from "./questionnaireEdit.vue?vue&type=style&index=0&id=b40f425a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports